module.exports = __webpack_public_path__ + "static/img/activity_progress_bg.039a7698.png";